import request from "@/utils/request";
const qs = require("qs");

/**
 * @return Promise
 */
export function getSalesStatus(bsnDate, storeCode) {
  return request({
    baseURL: process.env.VUE_APP_HOST_API_BASE_V1,
    url: "/sales_management/store-pos/sales-status",
    method: "get",
    params: {
      bsnDate,
      storeCode,
    },
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: "repeat" });
    }
  });
}

/**
 * @return Promise
 */
export function getProductList(
  storeCode,
  depth01Code,
  depth02Code,
  depth03Code,
  productNameCode,
  optnFlag,
  excludeRegisteredProduct
) {
  return request({
    baseURL: process.env.VUE_APP_HOST_API_BASE_V1,
    url: "/common/product-codes-pos",
    method: "get",
    params: {
      storeCode,
      depth01Code,
      depth02Code,
      depth03Code,
      productNameCode,
      optnFlag,
      excludeRegisteredProduct,
    },
  });
}

/**
 * 매장별 상품 순서 저장
 * 전송한 상품의 SORT_NO만 갱신하므로 목록 밖(필터로 제외되었거나 다른 소분류) 상품 순서는 보존된다.
 * @param storeCode 매장코드
 * @param productOrders [{ productCode, order }, ...] 변경된 상품코드 순서(order=SORT_NO 슬롯)
 * @return Promise
 */
export function putProductOrder(storeCode, productOrders) {
  return request({
    baseURL: process.env.VUE_APP_HOST_API_BASE_V2,
    url: `/stores/${storeCode}/products-sort-no-resetting`,
    method: "put",
    data: productOrders,
  });
}

/**
 * @return Promise
 */
export function getSalesReceipt(salesId, isProductTotal, gcDiv, isDcListView) {
  return request({
    baseURL: process.env.VUE_APP_HOST_API_BASE_V1,
    url: "/sales_management/store-pos/sales-receipt",
    method: "get",
    params: {
      salesId,
      isProductTotal,
      gcDiv,
      isDcListView,
    },
  });
}
